import React from 'react';
import { NavLink } from 'react-router-dom';

const AdminNav = () => {
    return (
        <nav className='admin-nav' aria-label='Admin navigation'>
            <NavLink
                to='/admin-analytics'
                className={({ isActive }) =>
                    isActive
                        ? 'admin-nav-link is-active'
                        : 'admin-nav-link'
                }
            >
                Stats
            </NavLink>
            <NavLink
                to='/admin-reviews'
                className={({ isActive }) =>
                    isActive
                        ? 'admin-nav-link is-active'
                        : 'admin-nav-link'
                }
            >
                Avis
            </NavLink>
            <NavLink
                to='/admin-products'
                className={({ isActive }) =>
                    isActive
                        ? 'admin-nav-link is-active'
                        : 'admin-nav-link'
                }
            >
                Produits
            </NavLink>
            <NavLink
                to='/admin-realisables'
                className={({ isActive }) =>
                    isActive
                        ? 'admin-nav-link is-active'
                        : 'admin-nav-link'
                }
            >
                Réalisation
            </NavLink>
        </nav>
    );
};

export default AdminNav;
